import { LeadershipHero } from '../components/sections/LeadershipHero';
import { LeadershipProfiles } from '../components/sections/LeadershipProfiles';
import { LeadershipCTA } from '../components/sections/LeadershipCTA';

const Leadership = () => (
  <div>
    <LeadershipHero />
    <LeadershipProfiles />
    <LeadershipCTA />
  </div>
);

export default Leadership;
